import React, { useEffect, useMemo, useRef, useState } from "react";
import { TrimText, capitalizeFirstLetter, createSlider } from "../../../utils/commonfunction";
import Skeleton from "react-loading-skeleton";
import { Testimonials } from "../services/website.services";
import { useTranslation } from "react-i18next";

const WebsiteTestimonials = ({ id = "TestimonialsSlider" }) => {
  const [testimonialsData, setTestimonialsData] = useState([]);
  const [apiLoaded, setApiLoaded] = useState(false);
  const TestimonialsHomeSliderRef = useRef();
  const [ModalData, setModalData] = useState({});
  const { t } = useTranslation();

  useEffect(() => {
    Testimonials()
      .then((response) => {
        setApiLoaded(true);
        setTestimonialsData(response?.data?.list || []);
      })
      .catch((err) => {
        console.log("err", err);
      });
  }, []);

  useEffect(() => {
    if (TestimonialsHomeSliderRef?.current) {
      createSlider(`#${id}`, {
        loop: true,
        margin: 20,
        nav: true,
        dots: true,
        responsive: {
          0: {
            items: 1
          },
          600: {
            items: 1
          },
          1000: {
            items: 1
          }
        }
      });
    }
    setTimeout(() => {
      const elements = document.querySelectorAll('.testimonials_read_more');
      elements.forEach((elem) => {
        elem.setAttribute('onclick', 'readMoreTestimonials(event)');
      });
    }, 100);
  }, [TestimonialsHomeSliderRef, apiLoaded]);

  useMemo(() => {
    document.addEventListener('set_testimonial_data', function (e) {
      const { source } = e.detail;
      setModalData(JSON.parse(source));
    });
  }, []);

  return (
    <>
      {apiLoaded ? (
        testimonialsData.length ?
          <section className="testimonial-sec section-padding">
            <div className="container">
              <div className="heading-section d-flex flex-column align-items-center gap-2 mb-5">
                <h6>{t("website.home.web_our_testimonials")}</h6>
                <h4>{t("website.home.web_our_testimonials_text")}</h4>
              </div>
              <>
                {testimonialsData ? (
                  <div className="owl-carousel owl-theme enable-nav-flex" id={id} ref={TestimonialsHomeSliderRef}>
                    {testimonialsData &&
                      testimonialsData.map((item, index) => (
                        <div key={index} className="item">
                          <div className="testimonial-ui">
                            <figure>
                              <img src={item?.profile_image} alt="Pouring coffee" className="img-fluid" />
                            </figure>
                            <figcaption>
                              <div className="testimonial-info">
                                <h4>{item?.name}</h4>
                                <span>{item?.designation}</span>
                              </div>
                              <p>
                                {item?.testimonial_text.length > 250 ? (
                                  <>
                                    {capitalizeFirstLetter(TrimText(item?.testimonial_text, 250))}
                                    <span className="link-text cp testimonials_read_more" data-bs-target="#exampleModalToggle" data-bs-toggle="modal" data-source={JSON.stringify(item)}>{t("website.home.web_testimonial_link_read_more")}</span>
                                  </>
                                ) : (
                                  capitalizeFirstLetter(TrimText(item?.testimonial_text, 250))
                                )}
                              </p>
                            </figcaption>
                          </div>
                        </div>
                      ))}
                  </div>
                ) : null}
              </>
            </div>
          </section>
          : null
      ) : (
        <div className="row">
          <div className="col-lg-3 col-md-4 ">
            <Skeleton className="rounded-4" height={200} />
          </div>
          <div className="col-lg-3 col-md-4  d-none d-md-block">
            <Skeleton className="rounded-4" height={200} />
          </div>
          <div className="col-lg-3 col-md-4  d-none d-md-block">
            <Skeleton className="rounded-4" height={200} />
          </div>
          <div className="col-lg-3 col-md-4  d-none d-lg-block">
            <Skeleton className="rounded-4" height={200} />
          </div>
        </div>
      )}
      <div className="modal fade" id="exampleModalToggle" aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabIndex="-1">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">{ModalData?.name}</h1>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div className="modal-body">
              {ModalData?.testimonial_text}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default WebsiteTestimonials;
